import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { Subscription } from 'rxjs';
import { BuyerConfig } from '../../../auth/buyer-config/buyer-config.service.interface';

/**
 * Directive for automatically showing and hiding content based on the user's config settings
 * Like advance targeting questions can be added only when buyer has advanceTarget config settings enabled
 * Similar to *ngIf="config === advanceTarget" but without needing to pull in the auth service
 */
@Directive({
  selector: '[psConfigEnabled]',
})
export class ConfigEnabledDirective implements OnDestroy {
  private _hasView = false;
  private _configSettings: (keyof BuyerConfig)[] = [];
  private _subscription: Subscription;

  @Input() set psConfigEnabled(
    config: keyof BuyerConfig | (keyof BuyerConfig)[]
  ) {
    this._configSettings = Array.isArray(config) ? config : [config];
    this._updateView(this._authService.buyerConfig);
  }

  constructor(
    private readonly _authService: AuthService,
    private readonly _viewContainer: ViewContainerRef,
    private readonly _templateRef: TemplateRef<any>
  ) {
    this._subscription = this._authService.buyerConfig$.subscribe((config) => {
      this._updateView(config);
    });
  }

  private _isConfigEnabled(buyerConfig: BuyerConfig) {
    return this._configSettings.some((key) => buyerConfig[key]);
  }

  private _updateView(buyerConfig?: BuyerConfig) {
    if (!buyerConfig) {
      this._viewContainer.clear();
      this._hasView = false;
      return;
    }

    if (this._isConfigEnabled(buyerConfig) && !this._hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this._hasView = true;
    } else if (!this._isConfigEnabled(buyerConfig) && this._hasView) {
      this._viewContainer.clear();
      this._hasView = false;
    }
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
